import { extend } from "./tools/helper";

export const chartTypes = {};

const builtin = {};

export function get() {
    return extend(builtin, chartTypes);
}
//# sourceMappingURL=chartModule.js.map